import React from 'react';
import { Text, View } from '@upstox/upstox-ui';
// services
import LocaleService from 'modules/Localization';
// styles
import * as css from './styles';
// typings
import { Props } from './typings';

const EstimationChargesError: React.FC<Props> = ({ onRetry }) => (
  <View css={css.disclaimer}>
    <Text size="s" weight="bold">{LocaleService.translate('DISCLAIMER_TITLE')} </Text>
    <ul style={css.disclaimerCharges}>
      <li>
        <Text size="s" color="text.2">
          {LocaleService.translate('ESTIMATION_CHARGES_FAILURE')}
        </Text>
        <Text
          size="s"
          weight="bold"
          color="text.link"
          onClick={onRetry}
          style={css.retryLoading}
        >
          {LocaleService.translate('RETRY_LOADING')}
        </Text>
      </li>
    </ul>
  </View>
);

export default EstimationChargesError;
